// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"441":"d676735c","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"441":"fc2842e1288cb2be015b","532":"19ff4422b12bf55841ec","678":"a96de5f9304024771e08"}[chunkId] + ".js";
};